import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';
import {
  AbstractSecurityStorage,
  AuthInterceptor,
  DefaultLocalStorageService,
  OpenIdConfiguration,
  provideAuth,
  StsConfigHttpLoader,
  StsConfigLoader
} from 'angular-auth-oidc-client';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';
import { configId, ConfigSettings, DataService } from '../services/data.service';

export const stsHttpAuthLoaderFactory = (httpClient: HttpClient, dataService: DataService): StsConfigHttpLoader => {
  const config$ = httpClient.get<any>(`${environment.restCommConfigUrl}/config`).pipe(
    map((configSettings: any) => {
      dataService.configSettings = configSettings;
      return buildOpenIdConfiguration(configSettings);
    })
  );
  return new StsConfigHttpLoader(config$);
};

export function buildOpenIdConfiguration(configSettings: ConfigSettings): OpenIdConfiguration {
  const origin = window.location.origin;
  const config: OpenIdConfiguration = {
    authority: configSettings.restIdentityUrl,
    configId,
    clientId: 'encimainapp',
    scope: 'openid profile email offline_access impersonation common_api calendario_api',
    responseType: 'code',
    redirectUrl: `${origin}/callback`,
    postLoginRoute: '/',
    postLogoutRedirectUri: `${origin}/`,
    unauthorizedRoute: '/unauthorizeduser',
    autoUserInfo: true,
    secureRoutes: [
      `${configSettings.restIdentityUrl}/`,
      `${configSettings.restCommonUrl}/`,
      `${configSettings.restCalendarioUrl}/`
    ],
    silentRenew: true,
    useRefreshToken: true,
    ignoreNonceAfterRefresh: true, //lasciare disabilitato!!!!
    renewTimeBeforeTokenExpiresInSeconds: 600 //dieci minuti di lasco
  };
  return config;
}

export function provideAuthConfig(): Array<EnvironmentProviders | Provider> {
  return [
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useFactory: stsHttpAuthLoaderFactory,
        deps: [HttpClient, DataService]
      }
    }),
    { provide: AbstractSecurityStorage, useClass: DefaultLocalStorageService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ];
}
